import { useContext } from 'react';
import { EosSourcesFilterContext } from './EosSourcesFilterContextProvider';

export function useEosSourcesFilterContext() {
  const context = useContext(EosSourcesFilterContext);
  if (!context) {
    throw new Error('useEosSourcesFilterContext must be used within EosSourcesFilterContextProvider');
  }
  return context;
}
